<template>
  <div class="home-container">
    <button @click="test">
      点击测试
    </button>
    <br>
    methods{{ parameter.methods }}<br>
    to{{ parameter.to }}<br>
    amount{{ parameter.amount }}<br>
    uid:{{ parameter.uid }}<br>
  </div>
</template>

<script>
import * as http from '@/common/utils/request.js';
import { getRandomToken } from '@/common/utils/utils';
import Web3 from 'web3';

const queryString = require('query-string');
import { mapState } from 'vuex';
import {depositToken} from '@/contactLogic/test.js';

export default {
  name: 'Home',
  data() {
    return {
      projectData: {},
      parameter:{}
    };
  },
  components: {
    picFrame: () => import('@/components/basic/frame.vue'),
  },
  methods: {
   async test(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;

      const methods =  this.$data.parameter.methods;
      const to =  this.$data.parameter.to;
      const amount =  this.$data.parameter.amount;
      const uid =  this.$data.parameter.uid;
      const args={methods,to,amount,uid};
      const res = await depositToken(library, account, chainID,args);
      res.wait([1]);
      alert('交易成功');



    },
    getTokenPrice(price) {
      if (!price) {
        return false;
      }
      const res = Web3.utils.fromWei(price);
      return `${res} ETH`;
    },

    // 获取随机id项目信息
    async getProjectDetail() {
      try {
        const res = await http.fetchGet('/api/project', {});
        console.log(res);
        this.projectData = res.data.data;
        console.log(this.projectData);
      } catch (error) {
        console.log(error);
      }
    },
    // 随机读取下一个项目
    randomNext() {
      this.getProjectDetail();
    },
    // 随机toekn
    randomToken(tokens) {
      if (!tokens || tokens.length <= 0) {
        return '';
      }
      const randomToken = getRandomToken(tokens);
      return randomToken;
    },
    toProjectDetail(id) {
      this.$router.push(`/projectDetail/${id}`);
    },
  },
  mounted() {
    const parsed = queryString.parse(location.search);
    this.$data.parameter = parsed;
    console.log(this.$data.parameter);

  },
  created() {
    // this.getProjectDetail();

  },
  computed: {
        ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
        isReady() {
            return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
        }
}
};
</script>

<style lang="less" scoped>
.home-container {
  .home-wrapper {
    padding: 30px 0px;
    display: flex;
    .introduce {
      width: 500px;
      .intro-item {
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
        zoom: 1;
        .title {
          float: left;
          font-size: 18px;
          font-style: italic;
        }
        .value {
          float: right;
          color: rgba(255, 255, 255, 0.6);
          font-weight: 600;
        }
        // 清除浮动
        &:after {
          content: '';
          display: block;
          height: 0;
          clear: both;
          visibility: hidden;
        }
        &:hover {
          transform: scale(1.04);
          transition: all 0.3s ease-in-out;
        }
      }
      .btn-random {
        width: 100%;
        padding: 15px 0px;
        border: 1px dashed rgba(255, 255, 255, 0.3);
        outline: none;
        margin-top: 30px;
        &:hover {
          border: 1px solid #fff;
        }
      }
    }
  }
}
@media (max-width: 1025px) {
  .home-container {
    .home-wrapper {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .pic-frame {
        width: 90%;
      }
      .introduce {
        width: 90%;
        margin-top: 40px;
      }
    }
  }
}

@media (min-width: 1026px) {
  .home-container {
    .home-wrapper {
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      .pic-frame {
        width: 400px;
        // margin-left: 100px;
        // margin-right: 100px;
      }
      .introduce {
        width: 500px;
        margin-top: 0;
      }
    }
  }
}
</style>
